import { Button } from '@/components/shared/Button';
import { Panel } from '@/components/shared/Panel';

interface DataStatePanelProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function DataStatePanel({ title, description, actionLabel, onAction }: DataStatePanelProps): JSX.Element {
  return (
    <Panel
      title={title}
      description={description}
      action={
        actionLabel && onAction ? (
          <Button variant="secondary" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : undefined
      }
    />
  );
}
